import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { EventosModel, SelectModel } from "../models/EventosModel";
import { crearEventoService, obtenerEventoPorIDService, obtenerEventos, obtenerEventosSelect } from "../../../service/eventos/Eventos";
import { SimpleAlert } from "../../../../rbts/helpers";

export const useObtenerEventos = (realoadGrid: number) => {
  const [list, setList] = useState<EventosModel[]>([]);
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {
    const fetchPost = async () => {
      const res = await obtenerEventos()
        .then()
        .catch((error) => {
          history.push("/error/500");
        });
      if (res) {
        setList(res.rows);
        setLoading(false);
      }
    };

    fetchPost();
  }, [realoadGrid]);

  return { list, loading };
};

export const useCrearEvento = () => {
  const [loadingRequest, setLoadingRequest] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const history = useHistory();
  const crearEvento = async (evento: EventosModel) => {
    setLoadingRequest(false);
    setError(false);
    try {
      await crearEventoService(evento);
      setLoadingRequest(true);
      setError(false);
    } catch (error: any) {
      if (error && error.response) {
        const { message } = error.response.data;
        SimpleAlert(message, 3000, 'error');
        setLoadingRequest(true);
        setError(true);
      } else {
        history.push('/error/500');
      }
    }
  };
  return { crearEvento, loadingRequest, error };
};


export const useObtenerPorID = (id: number) => {
  const initModel: EventosModel = {
    id: 0,
    nombre: '',
    actual: false,
    fecha_inicio: new Date().toISOString().split('T')[0],
    fecha_fin: new Date().toISOString().split('T')[0],
    imagen: '',
    descripcion: '',
    ubicacion: '',
    organizador_nombre: '',
    organizador_imagen: '',
    mostrar_menus: false,
    mostrar_recargas: false,
    visible_app: true,
    status: {
      id: 0,
      name: '',
      code: '',
    },
  };
  const [initValues, setInitValues] = useState<any>(initModel);
  const [loadingRequest, setLoadingRequest] = useState<boolean>(true);

  const history = useHistory();
  useEffect(() => {
    const fetchPost = async () => {
      setLoadingRequest(true);
      const res = await obtenerEventoPorIDService(id)
        .then()
        .catch((error) => {
          history.push("/error/500");
        });

      if (res) {
        setInitValues(res);
        setLoadingRequest(false);
      }
    };
    if (id > 0) {
      fetchPost();
    } else {
      setInitValues(initModel);
      setLoadingRequest(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return { initValues, loadingRequest };
};

export const useObtenerEventosSelect = (realoadGrid: number) => {
  const [list, setList] = useState<SelectModel[]>([]);
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {
    const fetchPost = async () => {
      const res = await obtenerEventosSelect()
        .then()
        .catch((error) => {
          history.push("/error/500");
        });
      if (res) {
        setList(res);
        setLoading(false);
      }
    };

    fetchPost();
  }, [realoadGrid]);

  return { list, loading };
};
